
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { UsuarioActual } from '@view/a-login/login-controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop() public Item: any;
        @Prop() public Cargando: any;
        public Abierto: boolean = false;
        public get  Usuario() {
            return UsuarioActual;
        };

        
    }
